import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/HomeView',
    name: 'HomeView',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/infoPublish',
    name: 'infoPublish',
    component: () => import(/* webpackChunkName: "about" */ '../views/infoPublish.vue')
  },
  {
    path: '/uploadOrder',
    name: 'uploadOrder',
    component: () => import(/* webpackChunkName: "about" */ '../views/uploadOrder.vue')
  },
  {
    path: '/waifPages',
    name: 'waifPages',
    component: () => import(/* webpackChunkName: "about" */ '../views/waifPages.vue')
  },
  {
    path: '/buildPages',
    name: 'buildPages',
    component: () => import(/* webpackChunkName: "about" */ '../views/buildPages.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
